var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: _vm.PERMISSIONS.VIEW_PORTFOLIO,
          expression: "PERMISSIONS.VIEW_PORTFOLIO",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c(
        "b-card",
        {
          attrs: {
            "no-body": true,
            "footer-class": "px-3 py-2 card-footer-action",
          },
        },
        [
          _c(
            "b-card-body",
            { staticClass: "p-3 clearfix" },
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("i", {
                      staticClass:
                        "fa fa-cube bg-primary p-3 font-2xl mr-3 float-left",
                    }),
                    _c(
                      "div",
                      { staticClass: "h5 mb-0 mt-2" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.componentLabel) +
                            " \n            "
                        ),
                        _c(
                          "b-badge",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: _vm.component.isInternal
                                ? "tab-total"
                                : "tab-info",
                              title: _vm.$t(
                                "message.component_classification_desc"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.component.isInternal
                                  ? "INTERNAL"
                                  : "EXTERNAL"
                              )
                            ),
                          ]
                        ),
                        _c("b-badge"),
                      ],
                      1
                    ),
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.bottom",
                          modifiers: { hover: true, bottom: true },
                        },
                      ],
                      staticClass: "fa fa-sitemap",
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        "aria-hidden": "true",
                        title: _vm.$t("message.show_in_dependency_graph"),
                      },
                      on: { click: this.redirectToDependencyGraph },
                    }),
                  ]),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-row",
                        { staticClass: "d-none d-md-flex float-right" },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityCritical,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("severity.critical"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentCritical))]
                          ),
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityHigh,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("severity.high"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentHigh))]
                          ),
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityMedium,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("severity.medium"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentMedium))]
                          ),
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityLow,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("severity.low"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentLow))]
                          ),
                          _c(
                            "vue-easy-pie-chart",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticStyle: { "margin-right": "1rem" },
                              attrs: {
                                "bar-color": _vm.severityUnassigned,
                                "font-size": "14px",
                                "track-color": _vm.trackColor,
                                "scale-color": "",
                                "line-cap": "round",
                                "line-width": 3,
                                percent: 100,
                                size: 50,
                                animate: true,
                                title: _vm.$t("severity.unassigned"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentUnassigned))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              attrs: { slot: "footer", id: "component-info-footer" },
              slot: "footer",
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.componentDetailsModal",
                              modifiers: { componentDetailsModal: true },
                            },
                          ],
                          staticClass:
                            "font-weight-bold font-xs btn-block text-muted",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("message.view_details")) +
                              "\n            "
                          ),
                          _c("i", {
                            staticClass:
                              "fa fa-angle-right float-right font-lg",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.component.externalReferences
                    ? _c(
                        "b-col",
                        { attrs: { md: "auto" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "d-none d-md-flex float-right" },
                            [
                              _c("ExternalReferencesDropdown", {
                                attrs: {
                                  externalReferences:
                                    _vm.component.externalReferences,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: {
            "border-left": "0",
            "border-right": "0",
            "border-top": "0",
          },
        },
        [
          _c(
            "b-tab",
            {
              ref: "overview",
              staticClass: "body-bg-color overview-chart",
              staticStyle: {
                "border-left": "0",
                "border-right": "0",
                "border-top": "0",
              },
              attrs: { active: "" },
              on: {
                click: function ($event) {
                  return _vm.routeTo()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-line-chart" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.overview"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("component-dashboard", {
                staticStyle: {
                  "border-left": "0",
                  "border-right": "0",
                  "border-top": "0",
                },
              }),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              ref: "vulnerabilities",
              on: {
                click: function ($event) {
                  return _vm.routeTo("vulnerabilities")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-shield" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("message.vulnerabilities")) +
                          "\n        "
                      ),
                      _c("b-badge", { attrs: { variant: "tab-total" } }, [
                        _vm._v(_vm._s(_vm.totalVulnerabilities)),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("component-vulnerabilities", {
                key: this.uuid,
                attrs: { uuid: this.uuid },
                on: {
                  total: function ($event) {
                    _vm.totalVulnerabilities = $event
                  },
                },
              }),
            ],
            1
          ),
          _c("b-tab", {
            on: {
              click: function ($event) {
                return _vm.$router.push(
                  `/components#/search/PACKAGE_URL/${_vm.component.purl}`
                )
              },
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("i", { staticClass: "fa fa-cubes" }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.projects_also_used_in"))
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("component-details-modal", {
        attrs: { component: _vm.cloneDeep(_vm.component) },
        on: { componentUpdated: _vm.syncComponentFields },
      }),
      _c("component-properties-modal", { attrs: { uuid: this.uuid } }),
      _c("component-create-property-modal", { attrs: { uuid: this.uuid } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }